import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import BFormFieldWrapper from "./BFormFieldWrapper";

export default function BForm({
  preloadedData,
  fields,
  btnText,
  submit,
  scroll = "overflow-y-scroll",
  clearFormAfterSubmit = false,
  responseErrors,
  success,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({ defaultValues: preloadedData });

  const onSubmit = (data) => {
    if (clearFormAfterSubmit) {
      reset();
    }
    return submit(data);
  };
  
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`w-full px-6 pb-1 max-h-85vh ${scroll}`}
    >
      {fields &&
        fields.map((f) => (
          <BFormFieldWrapper
            key={f.fieldName}
            field={f}
            errors={errors}
            register={register}
            control={control}
          />
        ))}
      <div className="md:flex md:items-center">
        <div className="w-full flex items-center justify-center mt-4">
          <input
            className="shadow bg-blue-accent cursor-pointer hover:bg-blue-hover 
            focus:shadow-outline focus:outline-none text-white font-bold py-1 mb-1 px-3 rounded mx-auto"
            type="submit"
            value={btnText}
          />
        </div>
      </div>
      {responseErrors && 
        responseErrors.map((errorMessage, index) => (
          <div key={index} className="p-2 text-red-600 text-center">{errorMessage}</div>
        ))}
      {success && (
        <div className="p-2 text-green-600 text-center">
          Succesfully added!
        </div>
      )}
    </form>
  );
}

BForm.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      fieldName: PropTypes.string,
      placeholder: PropTypes.string,
      validation: PropTypes.object,
      type: PropTypes.string,
    })
  ),
  btnText: PropTypes.string,
  submit: PropTypes.func,
};
